export const FEATURE_FLAGS = {
  PERMISSION: {
    ADMIN_ROLE_ASSIGNMENT: "AdminRoleAssignment",
  },
  KILL_SWITCH: {
    DISABLE_CONSUME_DEPRECATED_ME_ENDPOINT: "DisableConsumeDeprecatedMeEndpoint",
    ADMIN_COURTESY_JUSSUB: "AdminCustomerCourtesyJussub"
  },
  RELEASE: {
    ENABLE_NEW_AUTH_SERVICE: "EnableNewAuthService",
  },
};

export const FEATURE_FLAG_TYPES = {
  KILL_SWITCH: "killSwitch",
  PERMISSION: "permission",
};
